module.exports = __webpack_public_path__ + "img/pIndex-t-slide4.8ae911cd.jpg";